import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';

export const GET_CRM_MANAGERS_ANALYTICS = createRequestTypes('GET_CRM_MANAGERS_ANALYTICS');
export const getCrmManagersAnalytics = {
  request: search => action(GET_CRM_MANAGERS_ANALYTICS[REQUEST], { search }),
  success: data => action(GET_CRM_MANAGERS_ANALYTICS[SUCCESS], { data }),
  failure: error => action(GET_CRM_MANAGERS_ANALYTICS[FAILURE], { error }),
};

export const GET_CRM_CLIENTS_ANALYTICS = createRequestTypes('GET_CRM_CLIENTS_ANALYTICS');
export const getCrmClientsAnalytics = {
  request: search => action(GET_CRM_CLIENTS_ANALYTICS[REQUEST], { search }),
  success: data => action(GET_CRM_CLIENTS_ANALYTICS[SUCCESS], { data }),
  failure: error => action(GET_CRM_CLIENTS_ANALYTICS[FAILURE], { error }),
};

export const GET_CRM_ANALYTICS = createRequestTypes('GET_CRM_ANALYTICS');
export const getCRMAnalytics = {
  request: data => action(GET_CRM_ANALYTICS[REQUEST], { data }),
  success: data => action(GET_CRM_ANALYTICS[SUCCESS], { data }),
  failure: error => action(GET_CRM_ANALYTICS[FAILURE], { error }),
};
